import $ from "jquery";
import "foundation-sites";

import jqueryUjsInit from "jquery-ujs";
jqueryUjsInit($);

import Turbolinks from "turbolinks";
Turbolinks.start();

const afterLoadHooks = new Map();

function registerAfterLoadHook(id, callback) {
  afterLoadHooks.set(id, callback);
}

window.registerAfterLoadHook = registerAfterLoadHook;

document.addEventListener("turbolinks:load", () => {
  window.scrollTo(0, 0);

  afterLoadHooks.forEach((callback) => {
    try {
      callback();
    } catch (e) {
      console.error(e);
    }
  });

  $(document).foundation();
});

import "./topbar";
import "./logged_in_state";

import { Application } from "@hotwired/stimulus";

window.Stimulus = Application.start();
